import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';

import ViewWithFilters from './ViewWithFilters';

const Block = ({ entity, totalPages, filters }) => {
  const [blockType, blockId] = entity.getIn(['field_block_id', 0, 'value']).split(':');
  const [currentPage, setCurrentPage] = useState(0);

  // We only support view blocks for now.
  if (blockType === 'views') {
    // eslint-disable-next-line prefer-const
    let [viewId, viewDisplay] = blockId.split('-');


    if (
      (viewId === 'news' && viewDisplay === 'all') ||
      (viewId === 'course_info_overview' && viewDisplay === 'block_1')
    ) {
      return <ViewWithFilters id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />;
    }

    return (
      <div>
        <View id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} entity={entity} filters={filters} />
      </div>
    );
  }

  return null;
};

export default Block;
